import React from 'react';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import TravellerFields from './TravellerFields/TravellerFields';
import Button from '../../../BaseComponents/Button';
import Link from '../../../Link';
import ModalConfirm from '../../../ModalConfirm';
import { useRenderers } from '../../../renderProps';
const LinkCardsModal = ({ travellers, userInfo, onOpenConnectModal, onGoToAccountLoyalty, isLoading, onSubmit, error, onClearError, isOpen, onClose, hasLoyaltyProgramURL }) => {
    const FORM_NAME = 'UPDATE_FFP_FORM';
    const theme = useTheme('Loyalty').LinkCardsModal;
    const { t } = useTranslation('LinkCardsModal');
    const { TravellerFields: TravellerFieldsOverride = TravellerFields } = useRenderers();
    const formRef = React.useRef(null);
    const defaultValues = React.useRef(null);
    const isLinkedFFP = Boolean(userInfo) && !userInfo.isFfpAuthorizationNeeded;
    const canCreateFFP = !isLinkedFFP;
    const onCloseModal = () => {
        onClose();
        formRef.current.reset(defaultValues.current);
    };
    const validate = (values) => {
        if (values.travellers && !values.travellers.some(traveller => traveller.loyaltyCardNumber)) {
            return {
                travellers: values.travellers.map(_ => ({
                    loyaltyCardNumber: t('At least one field must be filled in')
                }))
            };
        }
        return undefined;
    };
    return (React.createElement(ModalConfirm, { isOpen: isOpen, onClose: onCloseModal, size: "xlarge", title: React.createElement("div", { className: theme.header },
            React.createElement("h2", { className: theme.header__title }, t('Loyalty cards')),
            React.createElement("h3", { className: theme.header__desc }, t('Add participant loyalty program numbers'))), footer: React.createElement("div", { className: theme.footer },
            React.createElement("div", { className: theme.footer__info }, canCreateFFP ? (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    t('or you can'),
                    ' ',
                    React.createElement(Link, { action: onOpenConnectModal }, t('Register in our Loyalty Program'))),
                React.createElement("p", null, t('Don’t miss out! Get your card now and unlock rewards!')))) : (hasLoyaltyProgramURL && (React.createElement(Link, { action: onGoToAccountLoyalty, target: "_blank" }, t('Want to check your miles history?'))))),
            React.createElement(Button, { variant: "smallPrimary", type: "submit", isLoading: isLoading, form: FORM_NAME }, t('Confirm'))) },
        React.createElement("div", { className: theme.form_container },
            React.createElement(Form, { onSubmit: onSubmit, validate: validate }, ({ handleSubmit, form, values }) => {
                formRef.current = form;
                // hack for correct reset form values
                if (!defaultValues.current && values.travellers) {
                    defaultValues.current = values;
                }
                return (React.createElement("form", { onSubmit: handleSubmit, id: FORM_NAME }, travellers.map(traveller => (React.createElement(TravellerFieldsOverride, { key: traveller.id, traveller: traveller })))));
            })),
        React.createElement(ModalConfirm, { isOpen: !!error, title: t('Oops...'), onClose: onClearError, onConfirm: onClearError }, error)));
};
export default LinkCardsModal;
